<div class="sidebar" [style.width]="isCollapsed ? '70px' : '200px'" [style.left.px]="isMobileDevice && isCollapsed ? -70 : 0">
  <ul>
    <ng-container *ngIf="isMobileDevice; else notMobileMode">
      <div class="toggle" (click)="collapseClicked()">
        <img [src]="images.dashboard_icon" alt="" />
      </div>
    </ng-container>
    <ng-template #notMobileMode>
      <li [class.justify-center]="isCollapsed">
        <img [src]="images.dashboard_icon" (click)="collapseClicked()" alt="" />
      </li>
    </ng-template>
    <ng-container *ngFor="let item of menu">
      <ng-container *ngFlag="item.flag">
        <li
          *ngxPermissionsOnly="item.permissions"
          [ngClass]="{ 'justify-center': isCollapsed, active: activeRoute === item.link }"
          [attr.data-label]="isCollapsed ? item.title : ''"
          class="list"
          [class.sideMenu]="isCollapsed"
          (click)="movePage(item)">
          <img src="{{ item.icon }}" alt="" />
          {{ isCollapsed ? '' : item.title }}
          <!-- Unread chat count; overlaid on the icon when collapsed, same as the header badges -->
          <span class="menu-badge" *ngIf="item.slug === 'chat' && chatStore.totalUnread()" [class.menu-badge--collapsed]="isCollapsed">
            {{ chatStore.totalUnread() > 99 ? '99+' : chatStore.totalUnread() }}
          </span>
        </li>
      </ng-container>
    </ng-container>
  </ul>
</div>
